import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icons/facebook.svg'
import _imports_1 from '@/assets/icons/instagram.svg'
import _imports_2 from '@/assets/icons/youtube.svg'
import _imports_3 from '@/assets/icons/tiktok.svg'
import _imports_4 from '@/assets/icons/backstagepro.svg'
import _imports_5 from '@/assets/icons/bandcamp.svg'


const _hoisted_1 = { class: "left" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"right socials\"><a href=\"https://www.facebook.com/nightbanemetal/\" target=\"_blank\"><img src=\"" + _imports_0 + "\"></a><a href=\"https://www.instagram.com/nightbanemetal/\" target=\"_blank\"><img src=\"" + _imports_1 + "\"></a><a href=\"https://www.youtube.com/@NightbaneMetal\" target=\"_blank\"><img src=\"" + _imports_2 + "\"></a><a href=\"https://www.tiktok.com/@nightbanemetal\" target=\"_blank\"><img src=\"" + _imports_3 + "\"></a><a href=\"https://www.backstagepro.de/nightbane\" target=\"_blank\"><img src=\"" + _imports_4 + "\"></a><a href=\"https://nightbane-metal.bandcamp.com/\" target=\"_blank\"><img src=\"" + _imports_5 + "\"></a></div>", 1)
const _hoisted_3 = { class: "player-cont" }

import BgImage from '@/components/bg-image.vue'
import CoverPlayer from '@/components/cover-player.vue'
import { computed } from 'vue'
import { useRoute } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute()

const isHome = computed(() => route.fullPath === '/')


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", null, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_router_link, { to: "/" }, {
          default: _withCtx(() => [
            _createTextVNode("home")
          ]),
          _: 1
        }),
        _createTextVNode(" | "),
        _createVNode(_component_router_link, { to: "/about" }, {
          default: _withCtx(() => [
            _createTextVNode("about")
          ]),
          _: 1
        }),
        _createTextVNode(" | "),
        _createVNode(_component_router_link, { to: "/impressum" }, {
          default: _withCtx(() => [
            _createTextVNode("impressum")
          ]),
          _: 1
        })
      ]),
      _hoisted_2
    ]),
    _createVNode(_component_router_view),
    _createVNode(BgImage, { img: "/img/FullBg.png" }),
    _createElementVNode("div", {
      class: _normalizeClass({layout: isHome.value})
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(CoverPlayer, {
          "is-mini": !isHome.value
        }, null, 8, ["is-mini"])
      ])
    ], 2)
  ], 64))
}
}

})